module.exports = __webpack_public_path__ + "img/book21.e99ac6ba.jpg";